(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_media-text-block_"] && !Shopify.designMode) return;
  try {
    class MediaTextCarousel {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.media-text-block__slide');
      this.buttons = container.querySelectorAll('.media-text-block__button');
      this.progressBars = container.querySelectorAll('.media-text-block__progress-bar');
      this.autoplayEnabled = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000;
      this.currentIndex = 0;
      this.autoplayTimer = null;

      if (this.slides.length > 0) {
        this.init();
      }
    }

    init() {
      // Add click handlers
      this.buttons[0].addEventListener('click', () => this.prev());
      this.buttons[1].addEventListener('click', () => this.next());

      // Start autoplay if enabled
      if (this.autoplayEnabled) {
        this.startAutoplay();

        // Pause on hover
        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    showSlide(index) {
      // Handle wrapping
      if (index < 0) {
        index = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        index = 0;
      }

      // Remove active classes
      this.slides[this.currentIndex].classList.remove('is-active');
      this.progressBars[this.currentIndex].classList.remove('is-active');

      // Add active classes to new slide
      this.slides[index].classList.add('is-active');
      this.progressBars[index].classList.add('is-active');

      this.currentIndex = index;
    }

    next() {
      this.showSlide(this.currentIndex + 1);
    }

    prev() {
      this.showSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      if (this.autoplayEnabled && !this.autoplayTimer) {
        this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
      }
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize all carousels
  document.querySelectorAll('.media-text-block__carousel').forEach((carousel) => {
    new MediaTextCarousel(carousel);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["first-buy-passes"] && !Shopify.designMode) return;
  try {
    class FirstBuyPassesComponent extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-first-buy-button]');
      this.loader = this.querySelector('.first-buy-passes__loader');
      this.buttonText = this.querySelector('.first-buy-passes__text');

      if (this.button) {
        this.button.addEventListener('click', this.handleCheckout.bind(this));
      }
    }

    async handleCheckout(event) {
      event.preventDefault();

      if (this.button.disabled) return;

      const variantId = this.dataset.variantId;
      const discountCode = this.dataset.discountCode;

      if (!variantId) {
        console.error('[First Buy Passes] No variant ID found');
        return;
      }

      this.setLoading(true);

      try {
        // Add product to cart using Shopify Cart API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId),
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }

        // Build checkout URL with discount if applicable
        let checkoutUrl = '/checkout';

        if (discountCode && discountCode.trim() !== '') {
          checkoutUrl += `?discount=${encodeURIComponent(discountCode.trim())}`;
        }

        // Redirect to checkout
        window.location.href = checkoutUrl;
      } catch (error) {
        console.error('[First Buy Passes] Checkout error:', error);
        this.setLoading(false);
        this.showError(error.message || 'Unable to proceed to checkout. Please try again.');
      }
    }

    setLoading(isLoading) {
      if (isLoading) {
        this.button.disabled = true;
        this.buttonText.classList.add('hidden');
        this.loader.classList.remove('hidden');
      } else {
        this.button.disabled = false;
        this.buttonText.classList.remove('hidden');
        this.loader.classList.add('hidden');
      }
    }

    showError(message) {
      // Show native alert for simplicity (can be enhanced with custom UI)
      alert(message);
    }
  }

  // Register custom element
  if (!customElements.get('first-buy-passes-component')) {
    customElements.define('first-buy-passes-component', FirstBuyPassesComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["media-text-block_"] && !Shopify.designMode) return;
  try {
    class MediaTextCarousel {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.media-text-block__slide');
      this.buttons = container.querySelectorAll('.media-text-block__button');
      this.progressBars = container.querySelectorAll('.media-text-block__progress-bar');
      this.autoplayEnabled = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000;
      this.currentIndex = 0;
      this.autoplayTimer = null;

      if (this.slides.length > 0) {
        this.init();
      }
    }

    init() {
      // Add click handlers
      this.buttons[0].addEventListener('click', () => this.prev());
      this.buttons[1].addEventListener('click', () => this.next());

      // Start autoplay if enabled
      if (this.autoplayEnabled) {
        this.startAutoplay();

        // Pause on hover
        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    showSlide(index) {
      // Handle wrapping
      if (index < 0) {
        index = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        index = 0;
      }

      // Remove active classes
      this.slides[this.currentIndex].classList.remove('is-active');
      this.progressBars[this.currentIndex].classList.remove('is-active');

      // Add active classes to new slide
      this.slides[index].classList.add('is-active');
      this.progressBars[index].classList.add('is-active');

      this.currentIndex = index;
    }

    next() {
      this.showSlide(this.currentIndex + 1);
    }

    prev() {
      this.showSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      if (this.autoplayEnabled && !this.autoplayTimer) {
        this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
      }
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize all carousels
  document.querySelectorAll('.media-text-block__carousel').forEach((carousel) => {
    new MediaTextCarousel(carousel);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["related-products-pass"] && !Shopify.designMode) return;
  try {
    class RelatedPass {
  constructor(container) {
    this.container = container;
    this.slidesContainer = container.querySelector('[data-slides-container]');
    this.nextButton = container.querySelector('.related-pass__button--next');
    this.slides = Array.from(container.querySelectorAll('[data-slide]'));
    this.dots = Array.from(container.querySelectorAll('[data-dot]'));

    this.currentIndex = 0;
    this.slideCount = this.slides.length;
    this.isAnimating = false;

    this.init();
  }

  init() {
    if (!this.slidesContainer || this.slides.length === 0) return;

    this.updateActiveDot();

    this.nextButton?.addEventListener('click', () => this.next());
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    this.slidesContainer.addEventListener('scroll', () => this.handleScroll());
    window.addEventListener('resize', () => this.handleResize());
    this.handleResize();
  }

  handleScroll() {
    if (this.isAnimating) return;

    const scrollPosition = this.slidesContainer.scrollLeft;
    const slideWidth = this.getSlideWidth();
    const newIndex = Math.round(scrollPosition / slideWidth);

    if (newIndex !== this.currentIndex) {
      this.currentIndex = newIndex;
      this.updateActiveDot();
    }
  }

  handleResize() {
    this.scrollToSlide(this.currentIndex, false);
  }

  getSlideWidth() {
    const slide = this.slides[0];
    const style = getComputedStyle(slide);
    const width = slide.offsetWidth;
    const marginRight = parseInt(style.marginRight) || 0;
    const marginLeft = parseInt(style.marginLeft) || 0;
    return width + marginRight + marginLeft;
  }

  scrollToSlide(index, animate = true) {
    if (index < 0 || index >= this.slideCount) return;

    const slideWidth = this.getSlideWidth();
    const targetScroll = slideWidth * index;

    if (animate) {
      this.isAnimating = true;
      this.slidesContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    } else {
      this.slidesContainer.scrollLeft = targetScroll;
    }

    this.currentIndex = index;
    this.updateActiveDot();
  }

  next() {
    const newIndex =
      this.currentIndex === this.slideCount - 1 ? 0 : this.currentIndex + 1;
    this.scrollToSlide(newIndex);
  }

  goToSlide(index) {
    if (index >= 0 && index < this.slideCount) {
      this.scrollToSlide(index);
    }
  }

  updateActiveDot() {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
}

document.querySelectorAll('.related-pass-block__carousel').forEach(carousel => {
  new RelatedPass(carousel);
});
  } catch(e) { console.error(e); }
})();

})();
